export const timeout = (waitDuration: number) => {
  return new Promise((resolve) => setTimeout(resolve, waitDuration));
};
